/**
 * HTTP headers constants for API requests
 */

export const API_HEADERS_GET = {
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
} as const;

export const API_HEADERS_POST = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
} as const;

export const API_HEADERS_DELETE = {
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
} as const;

export const API_HEADERS_PUT = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
} as const;
